import {
	ifAuthenticated,
	ifNotAuthenticated,
	ifAuthenticatedOnline,
	AppTabs,
	Edit,
	Create,
	Index
} from '@/router/index'

import Fidelitycard from '@/components/fidelitycard/Fidelitycard'

export const fidelitycards = [
	{
		path: '/fidelitycards',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/fidelitycards/',
					text: 'Carte Fedeltà'
				}
			]
		},
		children: [
			{
				path: '/fidelitycards/',
				beforeEnter: ifAuthenticatedOnline,
				component: Index,
				props: {
					modelDef: 'fidelitycards',
					'action-icon': 'people',
					title: 'Carte Fedeltà'
				}
			}
		]
	},
	{
		path: '/fidelitycards/create',
		name: 'fidelitycards-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: route => ({
			modelDef: 'fidelitycards',
			defaultInput: route.params.defaultInput				? route.params.defaultInput				: null,
			redirect: route.params.redirect
		})
	},
	{
		path: '/fidelitycards/:id/edit',
		name: 'fidelitycards-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: route => ({
			modelDef: 'fidelitycards',
			id: parseInt(route.params.id),
			redirect: { modelDef: 'fidelitycards', id: parseInt(route.params.id) }
		})
	},
	{
		path: '/fidelitycards/:id',
		name: 'fidelitycards',
		beforeEnter: ifAuthenticatedOnline,
		component: Fidelitycard,
		props: route => ({
			id: parseInt(route.params.id)
		})
	}
]
